// @flow

const getProgressFromProgressArray = (progressArray: number[]): number => {
  // Calculate the total progress by summing all the progress values
  const totalProgress = progressArray.reduce(
    (total, progress) => total + progress,
    0,
  );

  // Now get the percentage by dividing the total progress by the length of the array and the max progress value
  return Math.round((totalProgress / (progressArray.length * 100)) * 100);
};

export default getProgressFromProgressArray;
